"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _FoodMenu = require("../../../FoodMenu.context");

var ItemBasicCondensed = function ItemBasicCondensed(_ref) {
  var itemId = _ref.itemId;
  return /*#__PURE__*/_react["default"].createElement("div", null);
};

var _default = ItemBasicCondensed;
exports["default"] = _default;